import { injectScript } from '@smh/utils/dom';

import type { ISmi24BlockAnalyticsService } from '@jtnews/shared/seedwork/frontend/domain';
import { BlockPlaceRepositoryConfig } from '@jtnews/shared/seedwork/frontend/domain';

import type { IBlockUseCase, BlockUseCaseConfig } from '../blocks';
import { BlockUseCase } from '../blocks';

export const SMI24_BLOCK_USE_CASE_KEY = 'smi24_block_use_case_key';
export type Smi24BlockUseCaseConfig = BlockUseCaseConfig & {
  deps: {
    analyticsService: ISmi24BlockAnalyticsService;
  };
};
export interface ISmi24BlockUseCase extends IBlockUseCase {
  inject(): void;
  getWidgetScript(partnerId: number): string;
  processViewAdd(): void;
  processClickAdd(): void;
}

export class Smi24BlockUseCase extends BlockUseCase implements ISmi24BlockUseCase {
  isVisible = false;
  private readonly _src = 'https://jsn.24smi.net/smi.js';
  private readonly _analyticsService: ISmi24BlockAnalyticsService;
  constructor(config: Smi24BlockUseCaseConfig) {
    super(config);
    const {
      deps: { analyticsService },
    } = config;
    this._analyticsService = analyticsService;
  }

  public setBlockPlace(blockPlaceConfig: BlockPlaceRepositoryConfig) {
    this._analyticsService.setBlockPlace(blockPlaceConfig);
  }

  public processViewAdd() {
    this._analyticsService.sendEventBlockShown();
  }
  public processClickAdd() {
    this._analyticsService.sendEventBlockClick();
  }

  public getWidgetScript(partnerId: number): string {
    return `
          <div class="smi24__informer smi24__auto" data-smi-blockid="${partnerId}"></div>
          <script>(window.smiq = window.smiq || []).push({});</script>
    `;
  }

  public inject(): void {
    void injectScript({
      src: this._src,
    });
  }
}
